export default __webpack_public_path__ + "static/media/agreement.acd3f5ec.pdf";